import Vue from "vue";
import Router from "vue-router";

// 跳转相同路由报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}

// 各模块组件
import dashboardRouter from "@/router/modules/dashboard";
import orderBillRouter from "@/router/modules/orderBillRouter";
import examineRouter from "@/router/modules/examineRouter";

Vue.use(Router);

export const uRoutes = [
    // 首页看板
    {
        path: '/',
        component: () => import('@/components/header.vue'),
        name: 'main',
        redirect: { name: 'dashboard' },
        children: [
            // 看板 路由
            dashboardRouter,
            // 订单发票 路由
            orderBillRouter,
            // 审批 路由
            examineRouter,
            {
                path: "/inquiry",
                component: () => import("@/view/inquiry/inquiry"),
                name: "inquiry",
                meta: { title: "询价清单" }
            },
            {
                path: "/inquiry_details",
                component: () => import("@/view/inquiry/inquiry-details"),
                name: "inquiry_details",
                meta: { title: "询价清单详情" }
            },
            {
                path: "/priceSheet",
                component: () => import("@/view/inquiry/priceSheet"),
                name: "priceSheet",
                meta: { title: "报价单" }
            },
            {
                path: "/purchase",
                component: () => import("@/view/purchase/purchase"),
                name: "purchase",
                meta: { title: "采购单" }
            },
            {
                path: "/purchaseorder",
                component: () => import("@/view/purchase/purchaseorder"),
                name: "purchaseorder",
                meta: { title: "采购单提交" }
            },
            {
                path: "/category-*",
                component: () => import('@/view/product/product-list.vue'),
                name: "category-list",
                meta: { title: '产品选购' }
            },
            {
                path: "/search",
                component: () => import('@/view/product/product-list.vue'),
                name: "search-list",
                meta: { title: '搜索结果' }
            },
            {
                path: '/goods-*',
                component: () => import('@/view/product/product-detail.vue'),
                name: 'product-detail',
                meta: { title: '产品详情' }
            },
            {
                path: '/member',
                component: () => import('@/view/member/index.vue'),
                name: 'member',
                meta: { title: '成员管理' }
            },
        ]
    },
    {
        path: "/404",
        component: () => import("@/view/404"),
        name: "404",
        meta: { title: "404未找到" }
    },
    {
        path: "/login",
        component: () => import("@/view/login"),
        name: "login",
        meta: { title: "瑞宝供应链" }
    },
    { path: "*", redirect: "/404" }
];

const router = new Router({
    mode: "history",
    // mode: 'hash',
    scrollBehavior: () => ({ y: 0 }),
    routes: uRoutes
});

// 全局路由守卫和登录鉴权的内容在src/permission.js
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js